import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CardDataCaptureComponent } from "./card-data-capture/card-data-capture.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ExpiryDateFormatterPipe } from "./expiry-date-formatter.pipe";
import { CardTokenViewComponent } from "./card-pages/card-token-view/card-token-view.component";
import { CardDataViewComponent } from "./card-pages/card-data-view/card-data-view.component";
import { VisaTransactionsComponent } from "./visa-transactions/visa-transactions.component";
import { CardFormattingDirective } from "./card-formatting.directive";
import { CardTypeDirective } from "./card-type.directive";
import { CoreModule } from "src/app/core/core.module";
import { ErrorDialogComponent } from "src/app/core/error-dialog/error-dialog.component";
import { FooterComponent } from "src/app/core/footer/footer.component";

@NgModule({
	declarations: [
		CardDataCaptureComponent,
		ExpiryDateFormatterPipe,
		CardTokenViewComponent,
		CardDataViewComponent,
		VisaTransactionsComponent,
		CardFormattingDirective,
		CardTypeDirective,
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		CoreModule,
		ErrorDialogComponent,
		FooterComponent,
	],
	providers: [ExpiryDateFormatterPipe],
	exports: [CardDataCaptureComponent, CardFormattingDirective],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardProcessingModule { }
